import {
  MessageBox
} from 'element-ui'

export function handleCofirm (text = '确定执行此操作吗？', type = 'warning') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: type
  })
}

export function onDownload (headers, data) {
  const fileName = window.decodeURI(
    headers['content-disposition'].split('=')[1],
    'UTF-8'
  )
  var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
  var downloadElement = document.createElement('a')
  var href = URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  downloadElement.download = fileName // 下载后文件名
  downloadElement.click() // 点击下载
  URL.revokeObjectURL(href) // 释放掉blob对象
}
// 统一处理参数参数时候下拉列表中动态获取的options的替换
export function optionsDataReplace (prop, list, data) {
  if(!prop || !Array.isArray(list)) return
  list.forEach(e => {
    if(e.prop === prop) {
      e.options = data
    }
  })
}
